import { Link } from 'wouter'

import {
  isSnapshotSelectable,
  isSnapshotSelected,
} from '#components/SnapshotLand/helpers'
import { SnapshotCard } from '#components/SnapshotLand/SnapshotCard'
import { useMst } from '#hooks'

import { useSnapshotData } from './useSnapshotLandData'

export const CurrentScriptCard = ({
  scriptId,
  icon,
  onClose,
  sticky = false,
}: {
  scriptId: string
  icon?: React.ReactNode
  onClose?: () => void
  sticky?: boolean
}) => {
  const { currentView, selectSnapshotUrl, snap1, snap2, trackSnapshotEvent } =
    useMst().view.snapshotLand

  const snapshotId = 'current'
  const opts = { snap1, snap2, currentView, snapshotId }
  const { data } = useSnapshotData({ scriptId, snapshotId })

  const card = (
    <SnapshotCard
      selected={isSnapshotSelected(opts)}
      data={data}
      variant="current-script"
      sticky={sticky}
      icon={icon}
      onClose={onClose}
    />
  )

  if (isSnapshotSelectable(opts)) {
    return (
      <Link
        asChild
        href={selectSnapshotUrl(snapshotId)}
        onClick={() => trackSnapshotEvent('SELECT_SNAPSHOT')}
      >
        {card}
      </Link>
    )
  }

  return card
}
